import PropTypes from 'prop-types';
import { omit } from 'lodash-es';

/**
 * Omits the specified keys from the .props of a PropTypes.shape object.
 *
 * @param {object} shapeValidator - The validator object returned by PropTypes.shape().
 * @param {string[]} keys - An array of keys to OMIT.
 * @returns {object} A new object containing the remaining prop types.
 */
export function omitFromShape(shapeValidator, keys) {
  return omit(shapeValidator.props, keys);
}

const ItemEntity = PropTypes.shape({ id: PropTypes.string.isRequired, innerGroupClassName: PropTypes.string });
const ControlEntity = PropTypes.shape({
  optionsKey: PropTypes.string,
  dataKey: PropTypes.string,
  classNames: PropTypes.string,
});

export const GroupConfigEntity = PropTypes.shape({
  groupId: PropTypes.string,
  title: PropTypes.string,
  isCollapsible: PropTypes.bool,
  isOpenOnLoad: PropTypes.bool,
  hideCollapseSeparator: PropTypes.bool,
  items: PropTypes.arrayOf(ItemEntity),
});

const FilterDefinitionEntity = PropTypes.shape({
  title: PropTypes.string,
  control: PropTypes.string,
  controlProps: ControlEntity,
});

export const ConnectedFilterItemEntity = PropTypes.shape({
  ...omitFromShape(FilterDefinitionEntity, ['controlProps']),
  controlProps: PropTypes.shape(omitFromShape(ControlEntity, ['optionsKey'])),
  ...omitFromShape(ItemEntity, ['innerGroupClassName']),
});
